module.exports = __webpack_public_path__ + "static/media/flowers_4.555abf2c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_4.csv
// module id = 761
// module chunks = 0